import { DateTime } from 'luxon';

/**
 * Format a date using luxon DateTime format strings
 * @param date - The date to format (Date, DateTime, or ISO string)
 * @param format - The luxon format string (e.g., 'yyyy-MM-dd', 'EEE MMM d, yyyy')
 * @param timeZone - Optional timezone to convert to before formatting
 * @returns Formatted date string, or empty string if date is invalid
 */
export function dateFormatter(
  date: Date | DateTime | string | null | undefined,
  format: string,
  timeZone?: string
): string {
  if (!date) {
    return '';
  }

  let dateTime: DateTime;

  if (DateTime.isDateTime(date)) {
    dateTime = date;
  } else if (typeof date === 'string') {
    dateTime = DateTime.fromISO(date);
  } else if (date instanceof Date) {
    dateTime = DateTime.fromJSDate(date);
  } else {
    return '';
  }

  if (timeZone) {
    dateTime = dateTime.setZone(timeZone);
  }

  if (!dateTime.isValid) {
    return '';
  }

  return dateTime.toFormat(format);
}

